export const Types = {
    LOGIN_SUCCESS: "LOGIN_SUCCESS", 
    LOGIN_FAILED: "LOGIN_FAILED",
    LOGOUT: "LOGOUT",
    REGISTER_SUCCESS: "REGISTER_SUCCESS",
    REGISTER_FAILED: "REGISTER_FAILED",
    UPDATE_PROFILE: "UPDATE_PROFILE",
    SET_MESSAGE: "SET_MESSAGE",
    CLEAR_MESSAGE: "CLEAR_MESSAGE",
    SET_USER: "SET_USER",
    UNSET_USER: "UNSET_USER",
    SET_USER_FAIL: "SET_USER_FAIL",
    SET_CSRF: "SET_CSRF",
}